import { render, staticRenderFns } from "./DashboardDialogAddProvider.vue?vue&type=template&id=3bff4639&"
import script from "./DashboardDialogAddProvider.vue?vue&type=script&lang=js&"
export * from "./DashboardDialogAddProvider.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDialogAddProvider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports